var routeStatusTooltipTemplate = require('html/templates/routeStatusTooltip')();
var deliveryStatusTooltipTemplate = require('html/templates/deliveryStatusTooltip')();
var deliveryInfoTooltipTemplate = require('html/templates/deliveryInfoTooltip')();
var notificationsTooltipTemplate = require('html/templates/notificationsTooltip')();
var customerTimestampTooltipTemplate = require('html/templates/customerTimestampTooltip')();
var customerCallLogTooltipTemplate = require('html/templates/customerCallLogTooltip')();
var driverInfoTooltipTemplate = require('html/templates/driverInfoTooltip')();
var routeProgressTooltipTemplate = require('html/templates/routeProgressTooltip')();
var routePrintedTooltipTemplate = require('html/templates/routePrintedTooltip')();
var util = require('js/lib/util');
var t = require('js/lib/translate').t;
var moment = require('js/lib/moment');

fleetCtrl.$inject = ['$scope', '$rootScope', '$controller', '$routeParams', '$filter', '$location', 'modal', 'clock', 'editRoute', 'editCustomer', 'load'];

function fleetCtrl($scope, $rootScope, $controller, $routeParams, $filter, $location,  modal, clock, editRoute, editCustomer, load) {

  $controller('planCtrl', { $scope: $scope });

  $scope.openEditRoute = editRoute.openEditRoute.bind(this, $scope);
  $scope.saveRoute = editRoute.saveRoute.bind(this, $scope);
  $scope.deleteEmptyRoute = editRoute.deleteEmptyRoute.bind(this, $scope);

  $scope.routeStatusTooltipTemplate = routeStatusTooltipTemplate;
  $scope.deliveryStatusTooltipTemplate = deliveryStatusTooltipTemplate;
  $scope.deliveryInfoTooltipTemplate = deliveryInfoTooltipTemplate;
  $scope.notificationsTooltipTemplate = notificationsTooltipTemplate;
  $scope.customerTimestampTooltipTemplate = customerTimestampTooltipTemplate;
  $scope.customerCallLogTooltipTemplate = customerCallLogTooltipTemplate;
  $scope.driverInfoTooltipTemplate = driverInfoTooltipTemplate;
  $scope.routeProgressTooltipTemplate = routeProgressTooltipTemplate;
  $scope.routePrintedTooltipTemplate = routePrintedTooltipTemplate;

  // EditCustomer-service (mappings)
  $scope.openEditCustomer = editCustomer.openEditCustomer.bind(this, $scope);
  $scope.saveCustomer = editCustomer.saveCustomer.bind(this, $scope);
  $scope.addDelivery = editCustomer.addDelivery.bind(this);
  $scope.deleteDelivery = editCustomer.deleteDelivery.bind(this);
  $scope.cancelDelivery = editCustomer.cancelDelivery.bind(this, $scope);
  $scope.undoCancelDelivery = editCustomer.undoCancelDelivery.bind(this, $scope);
  $scope.deleteCustomer = editCustomer.deleteCustomer.bind(this, $scope);
  $scope.cancelCustomer = editCustomer.cancelCustomer.bind(this, $scope);
  $scope.openMap = editCustomer.openMap.bind(this, $scope);

  $scope.routeFilter = {
    status: undefined
  };

  $scope.setRouteFilter = function($event, status) {
    $scope.routeFilter.status = status;
    $event.preventDefault();
  };

  $scope.countRouteFilter = function(status) {
    return $filter('fleetRoutes')($scope.routePlan.routes, {
      status: status
    }).length;
  };

  $scope.filter = {
    routeId: $routeParams.routeId,
    status: $routeParams.status,
    delayed: undefined
  };

  $scope.search = {
    text: $routeParams.search
  };

  $scope.setStatus = function($event, status, delayed) {
    $scope.filter.status = status;
    $scope.filter.delayed = delayed;
    $event.preventDefault();
  };

  $scope.countStatus = function(status, delayed) {
    var customers = $filter('filter')($scope.routePlan.customers, {
      routeId: $scope.filter.routeId
    });

    if (status === 'deviation') {
      return customers.reduce(function(count, customer) {
        return count + customer.filterDeliveries('deviation').length;
      }, 0);
    } else if (status === 'partiallyDelivered') {
      return customers.reduce(function(count, customer) {
        return count + customer.filterDeliveries('partiallyDelivered').length;
      }, 0);
    } else {
      return $filter('fleetCustomers')(customers, {
        status: status,
        delayed: delayed
      }).length;
    }
  };

  $scope.routeStatusClass = function(route) {
    var routeStatus = (route.timestampStop && 'finished') ||
                      (route.timestampStart && 'started') ||
                      'notStarted';

    if (routeStatus === 'started' && route.noGPS(false)) {
      routeStatus += ' no-gps';  // More than 5 minutes since the last GPS update
    }

    return routeStatus;
  };

  $scope.formatPhone = require('js/lib/util').formatPhone;
  $scope.driverName = require('js/lib/util').driverName;

  $scope.routeDelayByRouteId = function(routeId) {
    var route = $scope.routePlan.findRoute(routeId);
    if (route) {
      return route.delayForHumans();
    }
    return null;
  };

  $scope.estimatedTimeAdjustedByRoute = function(estimatedTimestamp, routeId) {
    var route = $scope.routePlan.findRoute(routeId);
    if (route && route.delayInMinutes()) {
      var minutes = route.delayInMinutes();
      if (minutes) {
        return moment(estimatedTimestamp).add(minutes, 'minutes');
      }
    }
    return estimatedTimestamp;
  };

  $scope.delayedCustomer = function(actually, estimated) {
    return util.delayForHumans(util.delayInMinutes(util.toDate(actually), util.toDate(estimated)));
  };

  $scope.exportPianoUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/piano/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
  };

  $scope.exportRouteMetaUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/routeMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
  };

  $scope.exportDeliveryMetaUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/deliveryMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
  };

  $scope.exportDeviationMetaUrl = function() {
    return $scope.baseUrl + '/pl/api/v-1/export/deviationMeta/' + $scope.routePlan.id + '?token=' + $rootScope.auth.token;
  };

  // Force the page to update every whole minute (to update any delays)
  clock.everyMinute(function() {
    $scope.$apply();
  });

  // Make sure the customerSystem-name allways is populated (even after later reloads - i.e. editing a customer)
  $scope.$watch('dataLoaded()', function(loaded) {
    if (loaded) {
      $scope.routePlan.customers.forEach(function(customer) {
        // Enable search on customerSystem.name/shortName
        customer.customerSystem = $scope.customerSystems[customer.customerSystemId];
      });
    }
  });

  $scope.canEditRouteInfo = function(routePlan) {
    return $rootScope.auth.roles.fleetManager ||
      ($rootScope.auth.roles.clientPlus && routePlan.hasAccessToAllCustomerSystems($rootScope.auth.customerSystemIds));
  };

  $scope.addPrint = function() {
    var prints = {};
    var username = $rootScope.username;
    var routePlanId = $rootScope.routePlan.id;

    if($rootScope.routePlan.prints.length){
      prints = $rootScope.routePlan.prints;
      function hasPrinted(print) {
        return print.userName === username;
      }
      //var userHasPrinted = prints.find(hasPrinted);
      var userHasPrinted = prints.filter(hasPrinted);
      userHasPrinted ? userHasPrinted[0].numberOfPrints ++ : prints.push({
        userName: username,
        numberOfPrints: 1
      });
    } else{
      prints = {
        userName: username,
        numberOfPrints: 1
      };
      $rootScope.routePlan.prints.push(prints);
    }

    load.incrementPrint(routePlanId, username);
  };

  $scope.unpublish = function(routePlan) {
    modal.open({
      scope: $scope,
      title: t('planRoutesUnpublishBtn'),
      body: t('planRoutesUnpublishBtnConfirm', routePlan.name, moment(routePlan.date).format('L')),
      onConfirm: function() {
        load.unpublishRoutePlan(routePlan.id).then(function() {
          $location.path($scope.router.link('plans'));
        });
      }
    });
  };
}

module.exports = fleetCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/controllers/fleetCtrl.js
 ** module id = 128
 ** module chunks = 1
 **/